import React from 'react';
import { PlayIcon, ClockIcon, HeartIcon, MoreHorizontalIcon, ArrowLeftIcon, DownloadIcon } from 'lucide-react';
interface Track {
  id: string;
  title: string;
  artist: string;
  album: string;
  duration: string;
  addedAt: string;
}
interface LibraryPlaylistViewProps {
  item: any;
  onBack: () => void;
}
export const LibraryPlaylistView = ({
  item,
  onBack
}: LibraryPlaylistViewProps) => {
  // Generate mock tracks if not provided
  const tracks: Track[] = Array(15).fill(0).map((_, i) => ({
    id: `track-${i}`,
    title: ['Blinding Lights', 'Save Your Tears', 'Bohemian Rhapsody', 'Stairway to Heaven', 'Imagine', 'Billie Jean', 'Smells Like Teen Spirit', 'Let It Be'][i % 8],
    artist: ['The Weeknd', 'Queen', 'Led Zeppelin', 'John Lennon', 'Michael Jackson', 'Nirvana', 'The Beatles'][i % 7],
    album: ['After Hours', 'A Night at the Opera', 'Led Zeppelin IV', 'Imagine', 'Thriller', 'Nevermind', 'Let It Be'][i % 7],
    duration: `${Math.floor(Math.random() * 2) + 2}:${Math.floor(Math.random() * 59).toString().padStart(2, '0')}`,
    addedAt: `${Math.floor(Math.random() * 30) + 1} days ago`
  }));
  const totalDuration = item.subtitle ? item.subtitle : '1 hr 12 min';
  const isLikedSongs = item.title === 'Liked Songs';
  return <div className="min-h-full bg-gradient-to-b from-[#333333] to-[#121212]" data-id="element-166">
      {/* Header */}
      <div className="p-6 flex flex-col md:flex-row items-start md:items-end space-y-6 md:space-y-0 md:space-x-6" data-id="element-167">
        <button onClick={onBack} className="absolute top-4 left-4 p-2 rounded-full bg-black/40 hover:bg-black/60 transition-colors" data-id="element-168">
          <ArrowLeftIcon className="w-5 h-5" data-id="element-169" />
        </button>
        <div className="w-48 h-48 flex-shrink-0 shadow-2xl" data-id="element-170">
          {isLikedSongs ? <div className="w-full h-full bg-gradient-to-br from-[#450af5] to-[#c4efd9] flex items-center justify-center" data-id="element-171">
              <HeartIcon className="w-24 h-24 text-white" data-id="element-172" />
            </div> : <img src={item.imageUrl} alt={item.title} className="w-full h-full object-cover" data-id="element-173" />}
        </div>
        <div className="flex flex-col justify-end" data-id="element-174">
          <p className="text-sm uppercase font-bold" data-id="element-175">Playlist</p>
          <h1 className="text-5xl font-bold my-2" data-id="element-176">{item.title}</h1>
          <div className="flex items-center text-sm text-gray-300 space-x-1" data-id="element-177">
            <span className="font-bold text-white" data-id="element-178">Spotify</span>
            <span data-id="element-179">•</span>
            <span data-id="element-180">{totalDuration}</span>
          </div>
        </div>
      </div>
      {/* Controls */}
      <div className="px-6 py-4 flex items-center space-x-4" data-id="element-181">
        <button className="bg-green-500 text-black rounded-full p-3 hover:scale-105 transition-transform" data-id="element-182">
          <PlayIcon className="w-8 h-8" data-id="element-183" />
        </button>
        <button className="text-white hover:text-green-500 transition-colors" data-id="element-184">
          <DownloadIcon className="w-8 h-8" data-id="element-185" />
        </button>
        <button className="text-white hover:text-green-500 transition-colors" data-id="element-186">
          <MoreHorizontalIcon className="w-8 h-8" data-id="element-187" />
        </button>
      </div>
      {/* Tracks list */}
      <div className="px-6 pb-28" data-id="element-188">
        <table className="w-full text-left text-gray-400" data-id="element-189">
          <thead data-id="element-190">
            <tr className="border-b border-white/10" data-id="element-191">
              <th className="py-2 w-12" data-id="element-192">#</th>
              <th className="py-2" data-id="element-193">TITLE</th>
              <th className="py-2 hidden md:table-cell" data-id="element-194">ALBUM</th>
              <th className="py-2 hidden md:table-cell" data-id="element-195">DATE ADDED</th>
              <th className="py-2 text-right" data-id="element-196">
                <ClockIcon className="w-5 h-5 inline" data-id="element-197" />
              </th>
            </tr>
          </thead>
          <tbody data-id="element-198">
            {tracks.map((track, index) => <tr key={track.id} className="hover:bg-white/10 group" data-id="element-199">
                <td className="py-3" data-id="element-200">
                  <span className="group-hover:hidden" data-id="element-201">{index + 1}</span>
                  <PlayIcon className="w-4 h-4 hidden group-hover:block" data-id="element-202" />
                </td>
                <td className="py-3" data-id="element-203">
                  <div className="flex items-center" data-id="element-204">
                    <div data-id="element-205">
                      <div className="text-white" data-id="element-206">{track.title}</div>
                      <div className="text-sm" data-id="element-207">{track.artist}</div>
                    </div>
                  </div>
                </td>
                <td className="py-3 hidden md:table-cell" data-id="element-208">{track.album}</td>
                <td className="py-3 hidden md:table-cell" data-id="element-209">{track.addedAt}</td>
                <td className="py-3 text-right" data-id="element-210">{track.duration}</td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
};